<template>
<div class="chapter">
<div class="inner_page">
<p class="C277"><a id="page_XXI">TIMELINE</a></p><a id="page_XXI">
</a><div class="C705"><a id="page_XXI">
<p class="C243"><strong>1863</strong></p>
<p class="C218"><img alt="" class="Image151" src="img/22_1.png" width="88%"/></p>
</a><p class="C219"><a id="page_XXI"></a><a id="page_XXII"><img alt="" class="Image151" src="img/23_1.png" width="88%"/></a></p><a id="page_XXII">
</a></div><a id="page_XXII">
</a><div class="C705"><a id="page_XXII">
<p class="C216"><strong>1864</strong></p>
<p class="C218"><img alt="" class="Image151" src="img/23_2.png"/></p>
</a><p class="C219"><a id="page_XXII"></a><a id="page_XXIII"><img alt="" class="Image151" src="img/24_1.png"/></a></p><a id="page_XXIII">
</a></div><a id="page_XXIII">
<div class="C705">
<p class="C216"><strong>1865</strong></p>
<p class="C218"><img alt="" class="Image151" src="img/24_2.png" width="99%"/></p>
<p class="C269">*Thomas Ayres, <em>Dark and Bloody Ground</em>, 263.</p>
</div>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 09_Timeline.vue?3c91ae1e